<template>
  <div v-if="current">
    <div class="row">
      <div class="col-md-6">
        <v-btn color="primary" @click="listByStatus(1)" class="mr-1">Agendadas</v-btn>
        <v-btn color="warning" @click="listByStatus(3)" class="mr-1">N. atendidas</v-btn>
        <v-btn color="error" @click="listByStatus(4)" class="mr-1">N. existe</v-btn>
        <v-btn color="success" @click="listByStatus(2)" class="mr-1">Atendidas</v-btn>
        <v-btn color="secondary" @click="listByStatus(0)">Todas</v-btn>
      </div>
      <v-col cols="12" sm="3">
        <v-text-field 
          label="Busca" 
          v-model="query" 
          @click:append="search()" 
          append-icon="mdi-magnify" 
          v-on:keyup.enter="search()"
          solo dense>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
    </div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Tipo</th>
          <th>Telefone</th>
          <th>Celular</th>
          <th>Data</th>
          <th>Status</th>
          <th>Avaliação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.contractClientName }}</td>
          <td>{{ item.typeName }}</td>
          <td>{{ item.contractClientTelephone }}</td>
          <td>{{ item.contractClientCellphone }}</td>
          <td>{{ item.expires | formatDate }}</td>
          <td>
            <v-btn x-small v-bind:color="colorStatus(item.status)">{{
              item.status | formatStatus
            }}</v-btn>
          </td>
          <td>
            <v-btn x-small v-bind:color="colorScore(item)">{{
              item | formatScore
            }}</v-btn>
          </td>
          <td>
            <v-btn v-if="item.status != 2" icon @click="view(item.id)" title="Ligar"><v-icon>mdi-phone</v-icon></v-btn>
            <v-btn v-if="item.status == 2" icon @click="view(item.id)" title="Visualizar"><v-icon>mdi-magnify</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: function () {
    return {
      current: [],
      query: "",
      dialog_loading: false
    };
  },
  created: function () {
    this.listByStatus(1);
  },
  methods: {
    view: function (id) {
      router.push({ path: `/contact/${id}` });
    },
    listByStatus: function (status) {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/contact/status/" + status, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao listar!");
          console.log(error);
        });
    },
    search: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/contact/name/" + this.query, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao procurar!");
          console.log(error);
        });
    },
    colorStatus: function (status) {
      var ret = "default";
      if (status == 1) {
        ret = "primary";
      } else if (status == 2) {
        ret = "success";
      } else if (status == 3) {
        ret = "warning";
      } else if (status == 4) {
        ret = "error";
      }
      return ret;
    },
    colorScore: function (item) {
      var ret = "default";
      if (item.status == 2) {
        if (item.score < 7) {
          ret = "error";
        } else if (item.score < 9) {
          ret = "warning";
        } else {
          ret = "success";
        }
      }
      return ret;
    },
  },
  filters: {
    formatStatus: function (value) {
      var ret = "desconhecido";
      if (value == 1) {
        ret = "Agendada";
      } else if (value == 2) {
        ret = "Atendida";
      } else if (value == 3) {
        ret = "Não atendida";
      } else if (value == 4) {
        ret = "Não existe";
      }
      return ret;
    },
    formatScore: function (item) {
      var ret = "-";
      if (item.status == 2) {
        ret = "" + item.score;
      }
      return ret;
    },
  },
};
</script>
